/**
 * Search Providers Index
 * Registers all search providers with the registry
 */

export { providerRegistry } from './registry';
export { DoctorSearchProvider } from './DoctorSearchProvider';
export { TaskSearchProvider } from './TaskSearchProvider';
export { NavigationProvider } from './NavigationProvider';

// Initialize registry with all providers
import { providerRegistry } from './registry';
import { DoctorSearchProvider } from './DoctorSearchProvider';
import { TaskSearchProvider } from './TaskSearchProvider';
import { NavigationProvider } from './NavigationProvider';

// Register providers
providerRegistry.register(DoctorSearchProvider);
providerRegistry.register(TaskSearchProvider);
providerRegistry.register(NavigationProvider);
